import CompanySummaryContainer from "./CompanySummary.styles";
import PageTitle from "components/Common/PageTitle/PageTitle";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingSpinner from "components/Common/LoadingSpinner/LoadingSpinner";
import { useCompanySummary, useSelectCompany } from "./hooks";
import { CompanySummaryContent } from "./CompanySummaryContent";
import { Box } from "@mui/material";
import Select from "components/Common/Select/Select";
import { useBQMQ } from "context/BQMQ.context";
import { useHistory } from "react-router-dom";
import { useMemo } from "react";

const CompanySummary: React.FC = () => {
    const selectCompany = useSelectCompany();
    const companySummary = useCompanySummary(selectCompany.id);
    const { companies, bqmqLoading } = useBQMQ();
    const history = useHistory();

    const companyOptions = useMemo(
        () =>
            companies
                .filter((comp: any) => !!comp.focus_list_flag)
                .map((comp: any) => ({
                    label: comp.label,
                    value: String(comp.value),
                })),
        [companies]
    );

    const handleCompanyChange = (value: string | number) => {
        if (value) {
            history.push(`/company/company-summary/${value}`);
        }
    };

    return (
        <CompanySummaryContainer>
            <PageTitle title="COMPANY SUMMARY" />

            {!selectCompany.id && (
                <>
                    <div className="noData">
                        <FontAwesomeIcon icon={faInfoCircle} fixedWidth />
                        <p>
                            Please{" "}
                            <span className="highlight">select a company</span>{" "}
                            to view <span className="highlight">summary</span>.
                        </p>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        {" "}
                        <div style={{ width: "300px" }}>
                            <Select
                                filterName="Company"
                                value=""
                                setValue={handleCompanyChange}
                                options={companyOptions}
                                loadingOptions={!!bqmqLoading}
                                searchable
                                showAll={false}
                                clearable={false}
                            />
                        </div>
                    </div>
                </>
            )}
            {companySummary.loading && (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="30vh"
                >
                    <LoadingSpinner />
                </Box>
            )}
            {companySummary.data && !companySummary.loading && (
                <CompanySummaryContent summary={companySummary.data} />
            )}
        </CompanySummaryContainer>
    );
};

export default CompanySummary;
